import { useKaiProApiClient } from '../../../useKaiProApiClient';

import { ScanNoteSyncRecord, useScanNoteSyncModel } from '../Models';
import { Syncer, SyncerProps, syncItemBatch } from './syncItemBatch';
import { SYNC_TIMEOUT_SECONDS } from './syncLib';

export const useScanNotesSyncer = ({ syncLogger, addError, addSuccess, isPausedRef }: SyncerProps): Syncer<ScanNoteSyncRecord> => {
  const kaiProApiClient = useKaiProApiClient();
  const model = useScanNoteSyncModel();

  return {
    model,
    syncLogger,
    addError,
    isPausedRef,
    sync: pendingItems =>
      syncItemBatch({
        pendingItems,
        model,
        addError,
        addSuccess,
        syncLogger,
        isPausedRef,
        syncOne: (scanId, item) => kaiProApiClient.bulkCreateScanNotes(scanId, [item.noteData], SYNC_TIMEOUT_SECONDS),
        batchSync: (scanId, items) => kaiProApiClient.bulkCreateScanNotes(scanId, items.map(item => item.noteData), SYNC_TIMEOUT_SECONDS),
        batchSize: 100,
        singleSyncConcurrencyLimit: 5,
      }),
  };
};
